module.exports = __webpack_public_path__ + "static/media/huddl.77da0285.png";